export const logoMark = (
  <svg width="580" height="89" viewBox="0 0 624.594 95.737">
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          class="cls-1"
          d="M40.567,14.6a38.777,38.777,0,0,1,15.578,3.164,42.842,42.842,0,0,1,12.9,8.6,40.085,40.085,0,0,1,8.844,12.9,39.476,39.476,0,0,1,3.245,15.9H73.02a31.033,31.033,0,0,0-2.6-12.577,32.923,32.923,0,0,0-17.281-17.28,31.748,31.748,0,0,0-25.152,0A32.923,32.923,0,0,0,10.71,42.593a30.984,30.984,0,0,0-2.6,12.577V95.737H0V55.17A40.227,40.227,0,0,1,40.567,14.6Z"
        />
        <path
          class="cls-1"
          d="M131.061,87.624A31.381,31.381,0,0,0,149.4,82.108,32.255,32.255,0,0,0,161.081,67.34h8.924A42.065,42.065,0,0,1,164.082,78.7a40.975,40.975,0,0,1-8.925,8.926,43.855,43.855,0,0,1-11.277,5.922,38.005,38.005,0,0,1-12.819,2.191A40.227,40.227,0,0,1,90.494,55.17a40.567,40.567,0,1,1,81.134,0v4.056H98.608a34.708,34.708,0,0,0,3.813,11.358,31.3,31.3,0,0,0,7.221,8.926,35.346,35.346,0,0,0,9.817,5.922A30.706,30.706,0,0,0,131.061,87.624Zm0-64.908a30.764,30.764,0,0,0-11.6,2.191,35.49,35.49,0,0,0-9.817,5.922,31.037,31.037,0,0,0-7.221,9.006,35.629,35.629,0,0,0-3.813,11.278h64.906A35.7,35.7,0,0,0,159.7,39.835a31.1,31.1,0,0,0-7.221-9.006,35.213,35.213,0,0,0-9.9-5.922A30.973,30.973,0,0,0,131.061,22.716Z"
        />
        <path
          class="cls-1"
          d="M189.356,95.737H181.4V14.6h7.952v70.75l71.581-70.976,5.516,5.519Z"
        />
        <path
          class="cls-1"
          d="M275.469,8.113V0h8.114V8.113Zm0,87.624V14.6h8.114V95.737Z"
        />
        <path
          class="cls-1"
          d="M412.236,87.624a31.383,31.383,0,0,0,18.336-5.516A32.253,32.253,0,0,0,442.255,67.34h8.926A42.125,42.125,0,0,1,445.257,78.7a40.971,40.971,0,0,1-8.924,8.926,43.855,43.855,0,0,1-11.277,5.922,38.015,38.015,0,0,1-12.82,2.191A40.227,40.227,0,0,1,371.669,55.17a40.567,40.567,0,1,1,81.134,0v4.056H379.782A34.71,34.71,0,0,0,383.6,70.584a31.327,31.327,0,0,0,7.22,8.926,35.384,35.384,0,0,0,9.816,5.922A30.717,30.717,0,0,0,412.236,87.624Zm0-64.908a30.774,30.774,0,0,0-11.6,2.191,35.529,35.529,0,0,0-9.816,5.922,31.067,31.067,0,0,0-7.22,9.006,35.63,35.63,0,0,0-3.814,11.278H444.69a35.68,35.68,0,0,0-3.814-11.278,31.087,31.087,0,0,0-7.221-9.006,35.179,35.179,0,0,0-9.9-5.922A30.98,30.98,0,0,0,412.236,22.716Z"
        />
        <path
          class="cls-1"
          d="M301.7,95.737h-7.952V14.6H301.7v70.75l71.581-70.976L378.8,19.9Z"
        />
        <path
          class="cls-1"
          d="M460.866,27.007V30.82h.071a8.054,8.054,0,0,1,2.658-3.253,6.689,6.689,0,0,1,3.989-.98v3.148a8.458,8.458,0,0,0-3.045.49,4.816,4.816,0,0,0-2.028,1.434,5.929,5.929,0,0,0-1.119,2.292,12.33,12.33,0,0,0-.35,3.1v8.046h-2.975V27.007Z"
        />
        <path
          class="cls-1"
          d="M481.3,43.939a8.208,8.208,0,0,1-5.107,1.538,9.27,9.27,0,0,1-3.76-.7,7.386,7.386,0,0,1-2.678-1.959,8.3,8.3,0,0,1-1.625-3.009A14.489,14.489,0,0,1,467.513,36a10.873,10.873,0,0,1,.63-3.777,9.016,9.016,0,0,1,1.766-2.975,8.036,8.036,0,0,1,2.695-1.959,8.237,8.237,0,0,1,3.41-.7,7.41,7.41,0,0,1,4,1,7.937,7.937,0,0,1,2.554,2.537,10.013,10.013,0,0,1,1.33,3.357,14.487,14.487,0,0,1,.3,3.464H470.661a7.25,7.25,0,0,0,.279,2.257,5.128,5.128,0,0,0,1.017,1.888A4.963,4.963,0,0,0,473.74,42.4a6.143,6.143,0,0,0,2.553.49,5.14,5.14,0,0,0,3.1-.875,4.229,4.229,0,0,0,1.593-2.658h2.938A7.231,7.231,0,0,1,481.3,43.939Zm-.717-11.615a5.06,5.06,0,0,0-4.741-3.113,5.181,5.181,0,0,0-2.081.4,4.794,4.794,0,0,0-1.591,1.1,5.292,5.292,0,0,0-1.051,1.625,6.223,6.223,0,0,0-.454,1.978H481.05A6.1,6.1,0,0,0,480.579,32.324Z"
        />
        <path
          class="cls-1"
          d="M489.376,27.007v2.868h.07a6.263,6.263,0,0,1,5.876-3.288,7.829,7.829,0,0,1,2.974.49,4.9,4.9,0,0,1,1.924,1.364,5.067,5.067,0,0,1,1.034,2.081,11.269,11.269,0,0,1,.3,2.677V45.093h-2.975V32.848a3.589,3.589,0,0,0-.98-2.658,3.634,3.634,0,0,0-2.692-.979,6.057,6.057,0,0,0-2.362.42,4.42,4.42,0,0,0-1.661,1.189,5.092,5.092,0,0,0-1,1.8,7.348,7.348,0,0,0-.333,2.257V45.093h-2.972V27.007Z"
        />
        <path
          class="cls-1"
          d="M504.909,32.341a8.421,8.421,0,0,1,1.679-3.008,7.909,7.909,0,0,1,2.765-2.011,10.121,10.121,0,0,1,7.573,0,7.947,7.947,0,0,1,2.746,2.011,8.419,8.419,0,0,1,1.678,3.008,12,12,0,0,1,.56,3.726,11.824,11.824,0,0,1-.56,3.708,8.442,8.442,0,0,1-1.678,2.992,7.755,7.755,0,0,1-2.746,1.994,10.37,10.37,0,0,1-7.573,0,7.721,7.721,0,0,1-2.765-1.994,8.444,8.444,0,0,1-1.679-2.992,11.853,11.853,0,0,1-.559-3.708A12.031,12.031,0,0,1,504.909,32.341Zm3.026,6.647a6.109,6.109,0,0,0,1.206,2.134,5.231,5.231,0,0,0,1.8,1.313,5.492,5.492,0,0,0,4.373,0,5.221,5.221,0,0,0,1.8-1.313,6.1,6.1,0,0,0,1.207-2.134,9.959,9.959,0,0,0,0-5.842A6.3,6.3,0,0,0,517.118,31a5.141,5.141,0,0,0-1.8-1.329,5.481,5.481,0,0,0-4.373,0,5.15,5.15,0,0,0-1.8,1.329,6.311,6.311,0,0,0-1.206,2.151,9.959,9.959,0,0,0,0,5.842Z"
        />
        <path
          class="cls-1"
          d="M539.469,45.093,535.8,30.716h-.071L532.09,45.093h-3.22l-5.8-18.086h3.288l4.091,14.8h.07l3.639-14.8h3.254l3.777,14.8h.071l4.059-14.8h3.076l-5.771,18.086Z"
        />
        <path
          class="cls-1"
          d="M550.107,32.341a8.436,8.436,0,0,1,1.679-3.008,7.909,7.909,0,0,1,2.765-2.011,10.121,10.121,0,0,1,7.573,0,7.947,7.947,0,0,1,2.746,2.011,8.419,8.419,0,0,1,1.678,3.008,12,12,0,0,1,.56,3.726,11.824,11.824,0,0,1-.56,3.708,8.442,8.442,0,0,1-1.678,2.992,7.755,7.755,0,0,1-2.746,1.994,10.37,10.37,0,0,1-7.573,0,7.721,7.721,0,0,1-2.765-1.994,8.46,8.46,0,0,1-1.679-2.992,11.853,11.853,0,0,1-.559-3.708A12.031,12.031,0,0,1,550.107,32.341Zm3.026,6.647a6.109,6.109,0,0,0,1.206,2.134,5.225,5.225,0,0,0,1.8,1.313,5.49,5.49,0,0,0,4.372,0,5.234,5.234,0,0,0,1.8-1.313,6.109,6.109,0,0,0,1.206-2.134,9.959,9.959,0,0,0,0-5.842A6.311,6.311,0,0,0,562.317,31a5.153,5.153,0,0,0-1.8-1.329,5.479,5.479,0,0,0-4.372,0,5.144,5.144,0,0,0-1.8,1.329,6.311,6.311,0,0,0-1.206,2.151,9.959,9.959,0,0,0,0,5.842Z"
        />
        <path
          class="cls-1"
          d="M572.6,27.007V30.82h.07a8.054,8.054,0,0,1,2.658-3.253,6.689,6.689,0,0,1,3.989-.98v3.148a8.458,8.458,0,0,0-3.045.49,4.816,4.816,0,0,0-2.028,1.434,5.929,5.929,0,0,0-1.119,2.292,12.33,12.33,0,0,0-.35,3.1v8.046H569.8V27.007Z"
        />
        <path
          class="cls-1"
          d="M584,20.115v14.8l8.257-7.906h3.986l-7.17,6.577,7.7,11.509H593L586.8,35.648,584,38.237v6.856h-2.975V20.115Z"
        />
        <path
          class="cls-1"
          d="M600.583,41.052a3.193,3.193,0,0,0,1.1,1.085,4.939,4.939,0,0,0,1.537.577,8.8,8.8,0,0,0,1.769.175,10.882,10.882,0,0,0,1.469-.105,5.306,5.306,0,0,0,1.415-.385,2.653,2.653,0,0,0,1.068-.822,2.195,2.195,0,0,0,.421-1.381,1.981,1.981,0,0,0-.876-1.75,7.409,7.409,0,0,0-2.186-.962q-1.311-.366-2.851-.664a14.7,14.7,0,0,1-2.85-.84,5.878,5.878,0,0,1-2.187-1.521,3.958,3.958,0,0,1-.875-2.729,4.331,4.331,0,0,1,.613-2.345,4.967,4.967,0,0,1,1.573-1.59,7.209,7.209,0,0,1,2.17-.91,9.992,9.992,0,0,1,2.395-.3,14.278,14.278,0,0,1,2.834.263,6.558,6.558,0,0,1,2.291.909,4.7,4.7,0,0,1,1.593,1.749,6.647,6.647,0,0,1,.7,2.746h-2.974a2.852,2.852,0,0,0-1.435-2.379,4.508,4.508,0,0,0-1.311-.507,6.825,6.825,0,0,0-1.452-.157,8.736,8.736,0,0,0-1.348.105,4.517,4.517,0,0,0-1.242.367,2.535,2.535,0,0,0-.91.7,1.78,1.78,0,0,0-.348,1.137,1.67,1.67,0,0,0,.543,1.277,4.292,4.292,0,0,0,1.381.84,12.106,12.106,0,0,0,1.887.56q1.052.228,2.1.472,1.12.246,2.187.594a7.122,7.122,0,0,1,1.889.928,4.515,4.515,0,0,1,1.331,1.452,4.265,4.265,0,0,1,.506,2.168,5.041,5.041,0,0,1-.681,2.729,5.332,5.332,0,0,1-1.785,1.749,7.439,7.439,0,0,1-2.484.928,14.675,14.675,0,0,1-2.745.261,12.725,12.725,0,0,1-2.87-.314,7.036,7.036,0,0,1-2.413-1.032,5.236,5.236,0,0,1-1.678-1.89,6.524,6.524,0,0,1-.7-2.85h2.975A3.34,3.34,0,0,0,600.583,41.052Z"
        />
        <path
          class="cls-1"
          d="M619.372,23.39a5.5,5.5,0,0,1,2.561.65,4.7,4.7,0,0,1,1.956,1.858,4.857,4.857,0,0,1,.014,5.017,4.818,4.818,0,0,1-1.933,1.866,5.355,5.355,0,0,1-5.18,0,4.819,4.819,0,0,1-1.936-1.866,4.869,4.869,0,0,1,.014-5.017,4.734,4.734,0,0,1,1.956-1.858A5.485,5.485,0,0,1,619.372,23.39Zm0,.79a4.589,4.589,0,0,0-2.15.548,4,4,0,0,0-1.644,1.571,4.193,4.193,0,0,0-.591,2.121,4.222,4.222,0,0,0,2.214,3.665,4.505,4.505,0,0,0,4.358,0,4.074,4.074,0,0,0,1.627-1.571,4.118,4.118,0,0,0,.586-2.094,4.193,4.193,0,0,0-.591-2.121,4.019,4.019,0,0,0-1.644-1.571A4.621,4.621,0,0,0,619.372,24.18ZM617.3,25.785h2a3.588,3.588,0,0,1,1.768.321,1.361,1.361,0,0,1,.7,1.2,1.217,1.217,0,0,1-.238.755,1.516,1.516,0,0,1-.752.489,1.384,1.384,0,0,1,.676.569,2.239,2.239,0,0,1,.243,1.1,2.6,2.6,0,0,0,.027.448,1.82,1.82,0,0,0,.112.314h-1.058a1.335,1.335,0,0,1-.124-.615,2.659,2.659,0,0,0-.148-.936.746.746,0,0,0-.4-.362,3.024,3.024,0,0,0-1.028-.12h-.725v2.033H617.3Zm1.058,2.367h.9a2.112,2.112,0,0,0,1.155-.221.682.682,0,0,0,.306-.581.65.65,0,0,0-.284-.562,2.358,2.358,0,0,0-1.2-.2h-.878Z"
        />
      </g>
    </g>
  </svg>
)

export const tilePattern = (
  <svg width="472" height="231" viewBox="0 0 472 231" fill="none">
    <g clipPath="url(#clip0_9_37)">
      <path
        d="M430.067 68.4834H434.237C433.025 60.6401 429.339 53.3862 423.714 47.7746C418.09 42.163 410.819 38.4857 402.957 37.2765V41.4365C409.72 42.6049 415.956 45.8312 420.809 50.6732C425.662 55.5153 428.896 61.7362 430.067 68.4834Z"
        fill="#D4D2A5"
      />
      <path
        d="M449.576 68.4835H453.677C452.358 55.504 446.588 43.3769 437.341 34.1519C428.095 24.927 415.94 19.17 402.93 17.854V21.9458C414.859 23.2328 425.988 28.5494 434.473 37.014C442.957 45.4785 448.286 56.5822 449.576 68.4835Z"
        fill="#D4D2A5"
      />
      <path
        d="M467.553 68.4834H471.655C470.286 50.7652 462.607 34.1205 450.007 21.5597C437.407 8.9989 420.718 1.35128 402.957 0V4.09182C419.632 5.43192 435.285 12.6449 447.119 24.4413C458.953 36.2378 466.196 51.8487 467.553 68.4834Z"
        fill="#D4D2A5"
      />
      <path
        d="M402.957 106.769V110.861C410.818 109.655 418.088 105.98 423.713 100.371C429.338 94.7614 433.024 87.5094 434.237 79.6677H430.067C428.901 86.4225 425.669 92.6524 420.816 97.504C415.963 102.356 409.725 105.592 402.957 106.769Z"
        fill="#D4D2A5"
      />
      <path
        d="M402.957 126.233V130.324C415.967 129.008 428.122 123.251 437.369 114.027C446.615 104.802 452.385 92.6745 453.704 79.695H449.603C448.308 91.5944 442.978 102.695 434.494 111.159C426.011 119.623 414.884 124.941 402.957 126.233Z"
        fill="#D4D2A5"
      />
      <path
        d="M402.957 144.1V148.192C420.715 146.839 437.401 139.192 450 126.634C462.599 114.077 470.28 97.4371 471.655 79.7223H467.553C466.193 96.3546 458.949 111.962 447.115 123.756C435.281 135.55 419.63 142.761 402.957 144.1Z"
        fill="#D4D2A5"
      />
      <path
        d="M323.063 27.0469V31.2069C330.923 29.9971 338.192 26.3193 343.814 20.7075C349.436 15.0958 353.12 7.84222 354.329 0L350.228 0C349.047 6.75246 345.804 12.9758 340.941 17.8177C336.078 22.6595 329.834 25.8831 323.063 27.0469Z"
        fill="#D4D2A5"
      />
      <path
        d="M323.063 46.5104V50.6022C336.068 49.2873 348.221 43.5342 357.466 34.3148C366.712 25.0953 372.485 12.9746 373.81 0L369.709 0C368.408 11.8945 363.075 22.9892 354.592 31.4473C346.11 39.9054 334.986 45.2197 323.063 46.5104Z"
        fill="#D4D2A5"
      />
      <path
        d="M323.063 64.378V68.4698C340.811 67.1038 357.484 59.4517 370.072 46.8954C382.66 34.3391 390.333 17.7062 391.706 0L387.604 0C386.246 16.6237 379.009 32.2245 367.187 44.017C355.364 55.8095 339.726 63.026 323.063 64.378Z"
        fill="#D4D2A5"
      />
      <path
        d="M350.173 148.206H354.274C353.065 140.364 349.382 133.11 343.759 127.498C338.137 121.886 330.868 118.209 323.008 116.999V121.091C329.787 122.262 336.036 125.497 340.899 130.352C345.763 135.206 349.002 141.442 350.173 148.206Z"
        fill="#D4D2A5"
      />
      <path
        d="M369.682 148.206H373.783C372.466 135.225 366.697 123.097 357.45 113.871C348.203 104.646 336.046 98.8898 323.036 97.5763V101.668C334.961 102.965 346.085 108.285 354.567 116.747C363.05 125.21 368.382 136.308 369.682 148.206Z"
        fill="#D4D2A5"
      />
      <path
        d="M387.591 148.206H391.692C390.325 130.496 382.654 113.858 370.065 101.299C357.477 88.7391 340.8 81.086 323.049 79.7223V83.8141C339.713 85.1692 355.352 92.3885 367.174 104.183C378.996 115.978 386.233 131.581 387.591 148.206Z"
        fill="#D4D2A5"
      />
      <path
        d="M268.542 68.4834H272.644C271.434 60.6507 267.757 53.4051 262.146 47.7949C256.535 42.1848 249.281 38.501 241.432 37.2765V41.4365C248.195 42.6049 254.431 45.8312 259.284 50.6732C264.137 55.5153 267.371 61.7362 268.542 68.4834Z"
        fill="#D4D2A5"
      />
      <path
        d="M288.051 68.4835H292.152C290.834 55.5081 285.068 43.3843 275.827 34.1599C266.586 24.9355 254.437 19.1759 241.432 17.854V21.9458C253.355 23.2434 264.475 28.5642 272.953 37.0273C281.431 45.4904 286.757 56.5882 288.051 68.4835Z"
        fill="#D4D2A5"
      />
      <path
        d="M305.96 68.4834H310.062C308.695 50.776 301.026 34.14 288.44 21.5806C275.854 9.0213 259.181 1.36682 241.432 0V4.09182C258.095 5.44733 273.732 12.6671 285.552 24.4621C297.372 36.2571 304.605 51.8594 305.96 68.4834Z"
        fill="#D4D2A5"
      />
      <path
        d="M241.432 106.769V110.861C249.292 109.653 256.561 105.977 262.186 100.368C267.81 94.7594 271.497 87.5086 272.712 79.6677H268.611C267.44 86.432 264.199 92.6688 259.332 97.5215C254.466 102.374 248.213 105.605 241.432 106.769Z"
        fill="#D4D2A5"
      />
      <path
        d="M241.432 126.233V130.324C254.442 129.008 266.598 123.251 275.844 114.027C285.09 104.802 290.861 92.6745 292.18 79.695H288.078C286.779 91.5926 281.447 102.691 272.964 111.154C264.482 119.616 253.358 124.936 241.432 126.233Z"
        fill="#D4D2A5"
      />
      <path
        d="M241.432 144.1V148.192C259.182 146.826 275.857 139.172 288.446 126.613C301.034 114.054 308.706 97.4173 310.075 79.7087H305.974C304.616 96.3339 297.38 111.936 285.557 123.731C273.735 135.526 258.096 142.745 241.432 144.1Z"
        fill="#D4D2A5"
      />
      <path
        d="M161.525 27.0469V31.2069C169.379 29.9898 176.64 26.309 182.257 20.698C187.874 15.0871 191.554 7.8375 192.763 0L188.662 0C187.489 6.75107 184.251 12.9747 179.393 17.8172C174.534 22.6596 168.293 25.8836 161.525 27.0469Z"
        fill="#D4D2A5"
      />
      <path
        d="M161.525 46.5104V50.6022C174.53 49.2873 186.682 43.5342 195.928 34.3148C205.174 25.0953 210.947 12.9746 212.272 0L208.171 0C206.87 11.8945 201.537 22.9892 193.054 31.4473C184.571 39.9054 173.448 45.2197 161.525 46.5104Z"
        fill="#D4D2A5"
      />
      <path
        d="M161.525 64.378V68.4698C179.273 67.1065 195.948 59.4553 208.537 46.8985C221.125 34.3417 228.798 17.7071 230.168 0L226.066 0C224.71 16.6247 217.474 32.227 205.651 44.02C193.828 55.8131 178.188 63.0287 161.525 64.378Z"
        fill="#D4D2A5"
      />
      <path
        d="M188.662 148.206H192.763C191.551 140.362 187.865 133.108 182.241 127.497C176.616 121.885 169.345 118.208 161.484 116.999V121.091C168.266 122.256 174.521 125.489 179.387 130.344C184.254 135.199 187.494 141.439 188.662 148.206Z"
        fill="#D4D2A5"
      />
      <path
        d="M208.157 148.206H212.258C210.942 135.225 205.172 123.097 195.925 113.871C186.678 104.646 174.522 98.8898 161.511 97.5763V101.668C173.436 102.965 184.56 108.285 193.043 116.747C201.525 125.21 206.857 136.308 208.157 148.206Z"
        fill="#D4D2A5"
      />
      <path
        d="M226.052 148.206H230.154C228.787 130.496 221.116 113.858 208.527 101.299C195.938 88.7391 179.262 81.086 161.511 79.7223V83.8141C178.176 85.1665 193.816 92.385 205.639 104.18C217.462 115.976 224.697 131.58 226.052 148.206Z"
        fill="#D4D2A5"
      />
      <path
        d="M107.018 68.4834H111.119C109.913 60.649 106.238 53.4012 100.626 47.7903C95.0145 42.1795 87.7579 38.497 79.9079 37.2765V41.4365C86.6685 42.6105 92.9008 45.8386 97.7531 50.6797C102.605 55.5207 105.841 61.7386 107.018 68.4834Z"
        fill="#D4D2A5"
      />
      <path
        d="M126.527 68.4835H130.628C129.31 55.5081 123.543 43.3843 114.303 34.1599C105.062 24.9355 92.9127 19.1759 79.9079 17.854V21.9458C91.8301 23.2434 102.951 28.5642 111.428 37.0273C119.906 45.4904 125.233 56.5882 126.527 68.4835Z"
        fill="#D4D2A5"
      />
      <path
        d="M144.436 68.4834H148.537C147.168 50.777 139.498 34.1425 126.913 21.5837C114.327 9.02489 97.6553 1.36954 79.9079 0V4.09182C96.5703 5.44733 112.207 12.6671 124.027 24.4621C135.847 36.2571 143.081 51.8594 144.436 68.4834Z"
        fill="#D4D2A5"
      />
      <path
        d="M79.9079 106.769V110.861C87.7589 109.657 95.0216 105.99 100.643 100.391C106.265 94.7924 109.953 87.553 111.174 79.7223H107.072C105.889 86.4732 102.644 92.6945 97.7814 97.5357C92.9192 102.377 86.6768 105.602 79.9079 106.769Z"
        fill="#D4D2A5"
      />
      <path
        d="M79.9079 126.233V130.324C92.9134 129.01 105.065 123.256 114.311 114.037C123.557 104.818 129.33 92.6969 130.655 79.7223H126.554C125.248 91.615 119.914 102.707 111.432 111.164C102.95 119.621 91.829 124.937 79.9079 126.233Z"
        fill="#D4D2A5"
      />
      <path
        d="M79.9079 144.1V148.192C97.6567 146.823 114.33 139.168 126.918 126.61C139.506 114.051 147.178 97.4163 148.551 79.7087H144.449C143.091 96.3339 135.855 111.936 124.033 123.731C112.211 135.526 96.5718 142.745 79.9079 144.1Z"
        fill="#D4D2A5"
      />
      <path
        d="M0 27.0469V31.2069C7.8616 29.9977 15.1324 26.3204 20.757 20.7088C26.3817 15.0972 30.0676 7.84334 31.2796 0L27.1099 0C25.9388 6.74727 22.705 12.9682 17.8517 17.8102C12.9983 22.6523 6.76298 25.8785 0 27.0469Z"
        fill="#D4D2A5"
      />
      <path
        d="M0 46.5104V50.6022C13.0055 49.2873 25.1576 43.5342 34.4034 34.3148C43.6493 25.0953 49.4223 12.9746 50.7473 0H46.646C45.3502 11.8964 40.0186 22.9937 31.5349 31.4528C23.0512 39.9118 11.9248 45.2245 0 46.5104Z"
        fill="#D4D2A5"
      />
      <path
        d="M0 64.378V68.4698C17.7486 67.1065 34.4234 59.4553 47.012 46.8985C59.6006 34.3417 67.2728 17.7071 68.6428 0H64.5415C63.1828 16.6237 55.9463 32.2245 44.1238 44.017C32.3014 55.8095 16.6627 63.026 0 64.378Z"
        fill="#D4D2A5"
      />
      <path
        d="M27.1099 148.206H31.2796C30.0676 140.362 26.3817 133.108 20.757 127.497C15.1324 121.885 7.8616 118.208 0 116.999L0 121.091C6.77008 122.269 13.0093 125.507 17.8626 130.361C22.716 135.216 25.946 141.448 27.1099 148.206Z"
        fill="#D4D2A5"
      />
      <path
        d="M46.6186 148.206H50.72C49.4045 135.23 43.6388 123.104 34.3974 113.879C25.1561 104.655 13.0057 98.8957 0 97.5763L0 101.668C11.9213 102.968 23.0404 108.29 31.5178 116.752C39.9951 125.215 45.3225 136.311 46.6186 148.206Z"
        fill="#D4D2A5"
      />
      <path
        d="M64.5278 148.206H68.6292C67.2627 130.498 59.5937 113.862 47.0077 101.303C34.4216 88.7436 17.7484 81.0891 0 79.7223V83.8141C16.6624 85.1696 32.2995 92.3894 44.1195 104.184C55.9394 115.979 63.1727 131.582 64.5278 148.206Z"
        fill="#D4D2A5"
      />
      <path
        d="M430.067 226.291H434.237C433.033 218.441 429.35 211.177 423.725 205.558C418.1 199.938 410.825 196.255 402.957 195.043V199.203C409.726 200.374 415.965 203.607 420.819 208.457C425.673 213.307 428.904 219.537 430.067 226.291Z"
        fill="#D4D2A5"
      />
      <path
        d="M449.576 226.291H453.677C452.358 213.312 446.588 201.185 437.341 191.96C428.095 182.735 415.94 176.978 402.93 175.662V179.754C414.857 181.045 425.984 186.364 434.467 194.827C442.95 203.291 448.281 214.392 449.576 226.291Z"
        fill="#D4D2A5"
      />
      <path
        d="M467.553 226.291H471.655C470.288 208.582 462.617 191.944 450.028 179.384C437.439 166.825 420.763 159.172 403.012 157.808V161.9C419.678 163.249 435.32 170.467 447.143 182.263C458.966 194.059 466.2 209.664 467.553 226.291Z"
        fill="#D4D2A5"
      />
      <path
        d="M323.063 184.855V188.947C330.922 187.74 338.19 184.064 343.813 178.455C349.435 172.845 353.119 165.594 354.329 157.753H350.228C349.056 164.515 345.816 170.749 340.953 175.601C336.089 180.453 329.84 183.686 323.063 184.855Z"
        fill="#D4D2A5"
      />
      <path
        d="M323.063 204.318V208.41C336.073 207.094 348.228 201.337 357.474 192.112C366.721 182.887 372.491 170.76 373.81 157.781H369.709C368.409 169.678 363.077 180.777 354.595 189.239C346.112 197.702 334.988 203.022 323.063 204.318Z"
        fill="#D4D2A5"
      />
      <path
        d="M323.063 222.186V226.278C340.813 224.911 357.488 217.257 370.076 204.698C382.664 192.139 390.336 175.503 391.706 157.794H387.604C386.246 174.419 379.01 190.022 367.188 201.817C355.366 213.611 339.727 220.831 323.063 222.186Z"
        fill="#D4D2A5"
      />
      <path
        d="M268.542 226.291H272.644C271.442 218.451 267.769 211.196 262.157 205.578C256.545 199.96 249.287 196.27 241.432 195.043V199.203C248.201 200.374 254.441 203.607 259.295 208.457C264.149 213.307 267.379 219.537 268.542 226.291Z"
        fill="#D4D2A5"
      />
      <path
        d="M288.051 226.291H292.152C290.833 213.312 285.063 201.185 275.817 191.96C266.57 182.735 254.415 176.978 241.405 175.662V179.754C253.33 181.05 264.455 186.37 272.937 194.833C281.419 203.295 286.751 214.394 288.051 226.291Z"
        fill="#D4D2A5"
      />
      <path
        d="M305.96 226.291H310.062C308.695 208.584 301.026 191.948 288.44 179.389C275.854 166.829 259.181 159.175 241.432 157.808V161.9C258.096 163.253 273.735 170.471 285.555 182.267C297.375 194.062 304.608 209.666 305.96 226.291Z"
        fill="#D4D2A5"
      />
      <path
        d="M161.525 184.855V188.947C169.37 187.735 176.625 184.065 182.241 178.467C187.857 172.869 191.542 165.634 192.763 157.808H188.662C187.487 164.558 184.249 170.781 179.39 175.623C174.532 180.465 168.292 183.69 161.525 184.855Z"
        fill="#D4D2A5"
      />
      <path
        d="M161.525 204.318V208.41C174.534 207.094 186.69 201.337 195.936 192.112C205.183 182.887 210.953 170.76 212.272 157.781H208.171C206.871 169.678 201.539 180.777 193.056 189.239C184.574 197.702 173.45 203.022 161.525 204.318Z"
        fill="#D4D2A5"
      />
      <path
        d="M161.525 222.186V226.278C179.275 224.914 195.952 217.261 208.541 204.701C221.13 192.142 228.801 175.504 230.168 157.794H226.066C224.711 174.42 217.475 190.024 205.653 201.82C193.83 213.615 178.19 220.833 161.525 222.186Z"
        fill="#D4D2A5"
      />
      <path
        d="M107.018 226.291H111.119C109.921 218.449 106.249 211.193 100.637 205.574C95.0247 199.955 87.7638 196.266 79.9079 195.043V199.203C86.6742 200.38 92.9106 203.614 97.7636 208.463C102.616 213.312 105.849 219.539 107.018 226.291Z"
        fill="#D4D2A5"
      />
      <path
        d="M126.527 226.291H130.628C129.309 213.312 123.538 201.185 114.292 191.96C105.046 182.735 92.8903 176.978 79.8806 175.662V179.754C91.8058 181.05 102.93 186.37 111.412 194.833C119.895 203.295 125.227 214.394 126.527 226.291Z"
        fill="#D4D2A5"
      />
      <path
        d="M144.436 226.291H148.537C147.168 208.585 139.498 191.95 126.913 179.392C114.327 166.833 97.6553 159.177 79.9079 157.808V161.9C96.5703 163.255 112.207 170.475 124.027 182.27C135.847 194.065 143.081 209.667 144.436 226.291Z"
        fill="#D4D2A5"
      />
      <path
        d="M0 184.855V188.947C7.85267 187.743 15.1173 184.077 20.7413 178.478C26.3652 172.879 30.0563 165.64 31.2796 157.808H27.1099C25.9369 164.554 22.7025 170.774 17.8495 175.616C12.9965 180.458 6.76218 183.685 0 184.855Z"
        fill="#D4D2A5"
      />
      <path
        d="M0 204.318V208.41C13.0055 207.095 25.1576 201.342 34.4034 192.123C43.6493 182.903 49.4223 170.782 50.7473 157.808H46.646C45.3453 169.702 40.0121 180.797 31.5294 189.255C23.0466 197.713 11.923 203.028 0 204.318Z"
        fill="#D4D2A5"
      />
      <path
        d="M0 222.186V226.278C17.7486 224.914 34.4234 217.263 47.012 204.706C59.6006 192.15 67.2728 175.515 68.6428 157.808H64.5415C63.1828 174.432 55.9463 190.032 44.1238 201.825C32.3014 213.617 16.6627 220.834 0 222.186Z"
        fill="#D4D2A5"
      />
    </g>
    <defs>
      <clipPath id="clip0_9_37">
        <rect width="471.6" height="231" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const tileIcon = (
  <svg width="75" height="77" viewBox="0 0 75 77" fill="none">
    <g clipPath="url(#clip0_11_80)">
      <path
        d="M72.584 0H38.708V38.4935H75V0H72.584ZM72.584 36.0909H41.0714V2.40258H72.584V36.0909Z"
        fill="#1A1423"
      />
      <path
        d="M2.41597 40.9091H0V77.0391H36.292V40.9091H2.41597ZM33.9286 74.5843H2.41597V43.3116H33.9286V74.5843Z"
        fill="#1A1423"
      />
      <path
        d="M41.1371 40.9091H38.708V77.0391H75V40.9091H41.1371ZM72.6497 74.5843H41.1371V43.3116H72.6497V74.5843Z"
        fill="#1A1423"
      />
      <path d="M36.3051 0H4.84506V2.40258H36.3051V0Z" fill="#1A1423" />
      <path
        d="M36.3051 7.1947H4.84506V9.62339H36.3051V7.1947Z"
        fill="#1A1423"
      />
      <path
        d="M36.3051 14.4415H4.84506V16.8441H36.3051V14.4415Z"
        fill="#1A1423"
      />
      <path
        d="M36.3051 21.6754H4.84506V24.0519H36.3051V21.6754Z"
        fill="#1A1423"
      />
      <path
        d="M36.3051 28.8701H4.84506V31.2727H36.3051V28.8701Z"
        fill="#1A1423"
      />
      <path
        d="M36.3051 36.0909H4.84506V38.4935H36.3051V36.0909Z"
        fill="#1A1423"
      />
      <path d="M2.41597 0H0V2.40258H2.41597V0Z" fill="#1A1423" />
      <path d="M2.41597 7.22083H0V9.6234H2.41597V7.22083Z" fill="#1A1423" />
      <path d="M2.41597 14.4415H0V16.8441H2.41597V14.4415Z" fill="#1A1423" />
      <path d="M2.41597 21.6493H0V24.0519H2.41597V21.6493Z" fill="#1A1423" />
      <path d="M2.41597 36.0909H0V38.4935H2.41597V36.0909Z" fill="#1A1423" />
      <path d="M2.41597 28.8701H0V31.2727H2.41597V28.8701Z" fill="#1A1423" />
    </g>
    <defs>
      <clipPath id="clip0_11_80">
        <rect width="75" height="77" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const waterIcon = (
  <svg width="75" height="78" viewBox="0 0 75 78" fill="none">
    <g clipPath="url(#clip0_11_96)">
      <path d="M75 41.4404H45.969V43.8742H75V41.4404Z" fill="#1A1423" />
      <path d="M75 36.5596H45.969V38.9934H75V36.5596Z" fill="#1A1423" />
      <path
        d="M41.1371 34.1258H43.5531V31.6788V0H41.1371H38.708V2.43378H41.1371V4.88079H36.292V7.31457H41.1371V9.74835H38.708V12.1821H41.1371V14.6291H36.292V17.0629H41.1371V19.4967H38.708V21.9437H41.1371V24.3775H36.292V26.8113H41.1371V31.6788H33.8761V0H31.447V31.6788V34.1258H33.8761H41.1371Z"
        fill="#1A1423"
      />
      <path
        d="M43.553 38.9934H41.1371V43.8742H43.553V38.9934Z"
        fill="#1A1423"
      />
      <path d="M38.708 38.9934H36.292V46.308H38.708V38.9934Z" fill="#1A1423" />
      <path d="M43.553 46.308H41.1371V51.1888H43.553V46.308Z" fill="#1A1423" />
      <path
        d="M43.553 53.6226H41.1371V60.9371H43.553V53.6226Z"
        fill="#1A1423"
      />
      <path d="M38.708 48.7417H36.292V56.0563H38.708V48.7417Z" fill="#1A1423" />
      <path d="M38.708 58.5033H36.292V63.3841H38.708V58.5033Z" fill="#1A1423" />
      <path d="M29.031 36.5596H0V38.9934H29.031V36.5596Z" fill="#1A1423" />
      <path d="M29.031 41.4404H0V43.8742H29.031V41.4404Z" fill="#1A1423" />
      <path
        d="M65.3361 48.7417H58.0751V51.1755H65.3361V48.7417Z"
        fill="#1A1423"
      />
      <path
        d="M75.0131 48.7417H70.1681V51.1755H75.0131V48.7417Z"
        fill="#1A1423"
      />
      <path
        d="M70.1681 53.6226H62.907V56.0563H70.1681V53.6226Z"
        fill="#1A1423"
      />
      <path
        d="M72.5972 63.3708H67.7521V65.8046H72.5972V63.3708Z"
        fill="#1A1423"
      />
      <path
        d="M67.7521 70.6854H60.4911V73.1192H67.7521V70.6854Z"
        fill="#1A1423"
      />
      <path
        d="M75.0131 75.553H70.1681V77.9868H75.0131V75.553Z"
        fill="#1A1423"
      />
      <path d="M19.354 73.1193H9.677V75.553H19.354V73.1193Z" fill="#1A1423" />
      <path
        d="M12.1061 68.2517H7.26103V70.6855H12.1061V68.2517Z"
        fill="#1A1423"
      />
      <path
        d="M9.69013 63.3708H4.84506V65.8046H9.69013V63.3708Z"
        fill="#1A1423"
      />
      <path d="M12.093 58.5033H0V60.9371H12.093V58.5033Z" fill="#1A1423" />
      <path
        d="M12.1061 51.1887H4.84506V53.6225H12.1061V51.1887Z"
        fill="#1A1423"
      />
      <path
        d="M7.26103 46.308H2.41597V48.7418H7.26103V46.308Z"
        fill="#1A1423"
      />
      <path d="M16.938 46.308H12.093V48.7418H16.938V46.308Z" fill="#1A1423" />
      <path d="M26.615 48.7417H21.77V51.1755H26.615V48.7417Z" fill="#1A1423" />
      <path d="M50.8141 75.553H33.876V77.9868H50.8141V75.553Z" fill="#1A1423" />
      <path
        d="M33.876 36.5596H31.4601V41.4404H33.876V36.5596Z"
        fill="#1A1423"
      />
      <path
        d="M19.3671 56.0563H14.5221V58.4901H19.3671V56.0563Z"
        fill="#1A1423"
      />
      <path
        d="M26.615 65.8047H14.5221V68.2385H26.615V65.8047Z"
        fill="#1A1423"
      />
      <path d="M33.876 70.6854H29.031V73.1192H33.876V70.6854Z" fill="#1A1423" />
      <path
        d="M50.8141 68.2517H45.969V70.6855H50.8141V68.2517Z"
        fill="#1A1423"
      />
      <path
        d="M58.0751 65.8047H53.23V68.2385H58.0751V65.8047Z"
        fill="#1A1423"
      />
      <path d="M62.907 60.9371H55.646V63.3709H62.907V60.9371Z" fill="#1A1423" />
      <path
        d="M55.6591 53.6226H50.8141V56.0563H55.6591V53.6226Z"
        fill="#1A1423"
      />
      <path
        d="M55.6591 46.308H50.8141V48.7418H55.6591V46.308Z"
        fill="#1A1423"
      />
      <path
        d="M33.876 43.8741H31.4601V48.7549H33.876V43.8741Z"
        fill="#1A1423"
      />
      <path
        d="M33.876 51.1887H31.4601V58.5033H33.876V51.1887Z"
        fill="#1A1423"
      />
    </g>
    <defs>
      <clipPath id="clip0_11_96">
        <rect width="75" height="78" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const matIcon = (
  <svg width="77" height="65" viewBox="0 0 77 65" fill="none">
    <g clipPath="url(#clip0_11_134)">
      <path
        d="M27.6688 52.9668C26.4783 52.9668 25.3145 53.32 24.3246 53.9819C23.3347 54.6437 22.5631 55.5844 22.1075 56.685C21.6519 57.7855 21.5327 58.9966 21.765 60.165C21.9972 61.3333 22.5705 62.4066 23.4124 63.2489C24.2542 64.0912 25.3268 64.6649 26.4945 64.8973C27.6621 65.1297 28.8725 65.0104 29.9724 64.5545C31.0723 64.0987 32.0124 63.3267 32.6738 62.3362C33.3353 61.3457 33.6883 60.1812 33.6883 58.9899C33.6883 57.3925 33.0541 55.8605 31.9252 54.7309C30.7964 53.6014 29.2653 52.9668 27.6688 52.9668ZM27.6688 62.5959C26.9552 62.5856 26.2606 62.3643 25.6724 61.9598C25.0843 61.5554 24.6289 60.9858 24.3635 60.3229C24.0981 59.66 24.0347 58.9334 24.1811 58.2345C24.3276 57.5356 24.6774 56.8957 25.1866 56.3953C25.6957 55.8949 26.3414 55.5564 27.0424 55.4224C27.7435 55.2884 28.4684 55.3649 29.126 55.6423C29.7837 55.9197 30.3446 56.3856 30.7382 56.9813C31.1318 57.5769 31.3405 58.2758 31.338 58.9899C31.338 59.469 31.2427 59.9433 31.0575 60.3851C30.8723 60.827 30.601 61.2274 30.2594 61.5631C29.9178 61.8989 29.5128 62.1631 29.068 62.3404C28.6232 62.5178 28.1475 62.6046 27.6688 62.5959Z"
        fill="#1A1423"
      />
      <path
        d="M74.5844 9.62915H16.8442V0H0V2.40402H14.4416V50.5628H77.0392V48.1457H16.8442V45.7286H77.0392V43.3377H16.8442V40.9337H77.0392V9.57689L74.5844 9.62915ZM21.6493 38.5166V33.7085H38.4935V38.5166H21.6493ZM21.6493 26.4834H36.0909V31.3568H21.6493V26.4834ZM45.7012 38.5166V33.7085H64.961V38.5166H45.7012ZM45.7012 26.4834H57.7402V31.3568H45.7012V26.4834ZM74.5713 38.5166H67.3766V31.3568H60.1558V24.0794H43.3117V38.5166H40.9091V31.3568H38.4935V24.0794H19.2467V38.5166H16.8442V12.0332H74.5844L74.5713 38.5166Z"
        fill="#1A1423"
      />
      <path
        d="M63.7597 52.9668C62.5692 52.9668 61.4054 53.3201 60.4155 53.9819C59.4256 54.6437 58.654 55.5844 58.1984 56.685C57.7428 57.7856 57.6236 58.9966 57.8559 60.165C58.0881 61.3333 58.6614 62.4066 59.5033 63.2489C60.3451 64.0913 61.4177 64.6649 62.5854 64.8973C63.753 65.1297 64.9634 65.0104 66.0633 64.5546C67.1632 64.0987 68.1033 63.3267 68.7647 62.3362C69.4262 61.3457 69.7792 60.1812 69.7792 58.9899C69.7809 58.1985 69.6264 57.4145 69.3245 56.6829C69.0226 55.9514 68.5793 55.2867 68.02 54.7271C67.4607 54.1675 66.7964 53.7239 66.0653 53.4218C65.3342 53.1197 64.5507 52.9651 63.7597 52.9668ZM63.7597 62.596C63.0438 62.596 62.344 62.3834 61.7489 61.9851C61.1538 61.5869 60.6902 61.0209 60.4169 60.3588C60.1435 59.6967 60.0726 58.9684 60.2133 58.266C60.3539 57.5636 60.6997 56.9188 61.2068 56.4132C61.714 55.9075 62.3597 55.5639 63.0621 55.4257C63.7646 55.2876 64.4922 55.3611 65.1529 55.637C65.8136 55.9129 66.3776 56.3788 66.7734 56.9757C67.1693 57.5726 67.3792 58.2736 67.3766 58.9899C67.3732 59.9475 66.9906 60.8647 66.3127 61.5406C65.6347 62.2165 64.7167 62.596 63.7597 62.596Z"
        fill="#1A1423"
      />
    </g>
    <defs>
      <clipPath id="clip0_11_134">
        <rect width="77" height="65" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const installIcon = (
  <svg width="78" height="61" viewBox="0 0 78 61" fill="none">
    <g clipPath="url(#clip0_11_138)">
      <path
        d="M75.553 0H41.4404V61H78.0397V0H75.553ZM75.553 58.5637H43.8742V2.43629H75.553V58.5637Z"
        fill="#1A1423"
      />
      <path
        d="M56.0563 46.3425V51.2416H63.3709V46.3425H65.8047V14.6442H63.3709V9.75842H56.0563V14.6442H53.6225V46.3425H56.0563ZM60.9371 48.7788H58.5033V46.3425H60.9371V48.7788ZM58.5033 12.1947H60.9371V14.6442H58.5033V12.1947ZM56.0563 17.0805H63.3709V43.9195H56.0563V17.0805Z"
        fill="#1A1423"
      />
      <path d="M36.5728 0H4.88078V2.43629H36.5728V0Z" fill="#1A1423" />
      <path
        d="M36.5596 4.88586H24.3775V7.32216H36.5596V4.88586Z"
        fill="#1A1423"
      />
      <path
        d="M19.5099 4.88586H14.6291V7.32216H19.5099V4.88586Z"
        fill="#1A1423"
      />
      <path d="M2.43378 4.88586H0V7.32216H2.43378V4.88586Z" fill="#1A1423" />
      <path d="M12.1821 29.2753H0V31.7116H12.1821V29.2753Z" fill="#1A1423" />
      <path
        d="M29.245 29.2753H21.9305V31.7116H29.245V29.2753Z"
        fill="#1A1423"
      />
      <path
        d="M36.5596 14.6443H26.8112V17.0806H36.5596V14.6443Z"
        fill="#1A1423"
      />
      <path
        d="M19.4967 14.6443H9.74835V17.0806H19.4967V14.6443Z"
        fill="#1A1423"
      />
      <path
        d="M12.1954 19.5168H4.88078V21.9531H12.1954V19.5168Z"
        fill="#1A1423"
      />
      <path
        d="M24.3775 19.5168H17.0629V21.9531H24.3775V19.5168Z"
        fill="#1A1423"
      />
      <path
        d="M34.1258 19.5168H29.2451V21.9531H34.1258V19.5168Z"
        fill="#1A1423"
      />
      <path
        d="M36.5596 24.4026H19.4967V26.8389H36.5596V24.4026Z"
        fill="#1A1423"
      />
      <path
        d="M17.0629 24.4026H7.31456V26.8389H17.0629V24.4026Z"
        fill="#1A1423"
      />
      <path
        d="M36.5596 9.75842H34.1258V12.1947H36.5596V9.75842Z"
        fill="#1A1423"
      />
      <path
        d="M31.692 9.75842H14.6291V12.1947H31.692V9.75842Z"
        fill="#1A1423"
      />
      <path
        d="M9.76157 9.75842H4.88078V12.1682H9.76157V9.75842Z"
        fill="#1A1423"
      />
      <path
        d="M36.5596 34.161H26.8112V36.5973H36.5596V34.161Z"
        fill="#1A1423"
      />
      <path
        d="M21.9305 34.161H12.1821V36.5973H21.9305V34.161Z"
        fill="#1A1423"
      />
      <path
        d="M7.31456 34.161H4.88078V36.5973H7.31456V34.161Z"
        fill="#1A1423"
      />
      <path
        d="M36.5596 39.0337H24.3775V41.47H36.5596V39.0337Z"
        fill="#1A1423"
      />
      <path
        d="M19.4967 39.0337H17.0629V41.47H19.4967V39.0337Z"
        fill="#1A1423"
      />
      <path
        d="M12.1821 39.0337H9.74835V41.47H12.1821V39.0337Z"
        fill="#1A1423"
      />
      <path
        d="M36.5728 43.9194H31.692V46.3557H36.5728V43.9194Z"
        fill="#1A1423"
      />
      <path
        d="M29.2583 43.9194H24.3775V46.3557H29.2583V43.9194Z"
        fill="#1A1423"
      />
      <path
        d="M19.5099 43.9194H14.6291V46.3557H19.5099V43.9194Z"
        fill="#1A1423"
      />
      <path
        d="M7.31456 43.9194H4.88078V46.3557H7.31456V43.9194Z"
        fill="#1A1423"
      />
      <path d="M19.4967 48.792H0V51.2283H19.4967V48.792Z" fill="#1A1423" />
      <path d="M31.692 48.792H26.8112V51.2283H31.692V48.792Z" fill="#1A1423" />
      <path
        d="M36.5596 53.6779H21.9305V56.1141H36.5596V53.6779Z"
        fill="#1A1423"
      />
      <path
        d="M12.1954 53.6779H4.88078V56.1141H12.1954V53.6779Z"
        fill="#1A1423"
      />
      <path d="M36.5596 58.5637H29.2451V61H36.5596V58.5637Z" fill="#1A1423" />
      <path d="M24.3775 58.5637H14.6291V61H24.3775V58.5637Z" fill="#1A1423" />
      <path d="M2.43378 58.5637H0V61H2.43378V58.5637Z" fill="#1A1423" />
      <path d="M4.88079 14.6443H0V17.0806H4.88079V14.6443Z" fill="#1A1423" />
      <path
        d="M4.86756 24.4026H2.43378V26.8389H4.86756V24.4026Z"
        fill="#1A1423"
      />
      <path d="M7.31457 39.0337H0V41.47H7.31457V39.0337Z" fill="#1A1423" />
    </g>
    <defs>
      <clipPath id="clip0_11_138">
        <rect width="78" height="61" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const leftQuoteIcon = (
  <svg width="39" height="34" viewBox="0 0 39 34" fill="none">
    <g clipPath="url(#clip0_13_289)">
      <path
        d="M16.8235 17.0117H8.40018C8.40018 14.7527 9.28764 12.5862 10.8673 10.9889C12.447 9.39153 14.5895 8.49414 16.8235 8.49414V0C12.3617 0 8.08252 1.7923 4.9275 4.98262C1.77247 8.17293 0 12.4999 0 17.0117L0 33.9766H16.8235V17.0117Z"
        fill="#D4D2A5"
      />
      <path
        d="M39 8.49414V0C34.5381 0 30.259 1.7923 27.104 4.98262C23.949 8.17293 22.1765 12.4999 22.1765 17.0117V33.9766H39V17.0117H30.5767C30.5767 14.7527 31.4641 12.5862 33.0438 10.9889C34.6235 9.39153 36.766 8.49414 39 8.49414Z"
        fill="#D4D2A5"
      />
    </g>
    <defs>
      <clipPath id="clip0_13_289">
        <rect width="39" height="34" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const rightQuoteIcon = (
  <svg width="39" height="34" viewBox="0 0 39 34" fill="none">
    <g clipPath="url(#clip0_13_292)">
      <path
        d="M22.1765 16.9883L30.5998 16.9883C30.5998 19.2473 29.7124 21.4138 28.1327 23.0111C26.553 24.6085 24.4105 25.5059 22.1765 25.5059L22.1765 34C26.6383 34 30.9175 32.2077 34.0725 29.0174C37.2275 25.8271 39 21.5001 39 16.9883L39 0.0234299L22.1765 0.0234313L22.1765 16.9883Z"
        fill="#D4D2A5"
      />
      <path
        d="M-1.4094e-05 25.5059L-1.33514e-05 34C4.46186 34 8.741 32.2077 11.896 29.0174C15.051 25.8271 16.8235 21.5001 16.8235 16.9883L16.8235 0.0234299L-1.63218e-05 0.0234313L-1.48387e-05 16.9883L8.42334 16.9883C8.42334 19.2473 7.53588 21.4138 5.9562 23.0111C4.37651 24.6085 2.234 25.5059 -1.4094e-05 25.5059Z"
        fill="#D4D2A5"
      />
    </g>
    <defs>
      <clipPath id="clip0_13_292">
        <rect
          width="39"
          height="34"
          fill="white"
          transform="translate(39 34) rotate(180)"
        />
      </clipPath>
    </defs>
  </svg>
)

export const menuIcon = (
  <svg version="1.1" width="768" height="768" viewBox="0 0 768 768">
    <path d="M96 416h576c17.664 0 32-14.336 32-32s-14.336-32-32-32h-576c-17.664 0-32 14.336-32 32s14.336 32 32 32zM96 224h576c17.664 0 32-14.336 32-32s-14.336-32-32-32h-576c-17.664 0-32 14.336-32 32s14.336 32 32 32zM96 608h576c17.664 0 32-14.336 32-32s-14.336-32-32-32h-576c-17.664 0-32 14.336-32 32s14.336 32 32 32z"></path>
  </svg>
)

export const closeIcon = (
  <svg version="1.1" width="768" height="768" viewBox="0 0 768 768">
    <path d="M169.376 214.624l169.376 169.376-169.376 169.376c-12.512 12.512-12.512 32.768 0 45.248s32.768 12.512 45.248 0l169.376-169.376 169.376 169.376c12.512 12.512 32.768 12.512 45.248 0s12.512-32.768 0-45.248l-169.376-169.376 169.376-169.376c12.512-12.512 12.512-32.768 0-45.248s-32.768-12.512-45.248 0l-169.376 169.376-169.376-169.376c-12.512-12.512-32.768-12.512-45.248 0s-12.512 32.768 0 45.248z"></path>
  </svg>
)

export const igIcon = (
  <svg viewBox="0 0 44.07 44.07">
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path d="M33.18,0H10.89A10.91,10.91,0,0,0,0,10.89V33.18A10.91,10.91,0,0,0,10.89,44.07H33.18A10.91,10.91,0,0,0,44.07,33.18V10.89A10.91,10.91,0,0,0,33.18,0ZM33,13.91a2.8,2.8,0,1,1,2.8-2.8,2.8,2.8,0,0,1-2.8,2.8ZM22,11.54A10.5,10.5,0,1,1,11.54,22,10.5,10.5,0,0,1,22,11.54Z" />
        <path d="M22,28.35A6.32,6.32,0,1,0,15.72,22h0A6.32,6.32,0,0,0,22,28.35Z" />
      </g>
    </g>
  </svg>
)
